export async function appointmentOperationIndexUseCase(status, filter, m_type, appointmentRepostitory) {
    const result = await appointmentRepostitory.operation_index(status, filter, m_type);
    const array_result = [];

    result.data.data.forEach(x => {
      const entity = new appointmentRepostitory.model_operation(x.attributes);
    
      if (!entity.isValid()) {
        throw new Error("Appointment Operation Index inválido");
      }

      array_result.push(entity);
    })

    return array_result;
}